import { all } from 'redux-saga/effects';
import playerSaga from './playerSaga';
import brandSaga from './brandSaga';
import brandSettingSaga from './brandSettingSaga';
import notificationSaga from './notificationSaga';
import translationSaga from './translationSaga';
import templateSaga from './templateSaga';
import fileManagerSaga from './fileManagerSaga';
import gameSaga from './gameSaga';
import promoCodeSaga from './promoCodeSaga';
import bonusSaga from './bonusSaga';
import cashBackSaga from './cashBackSaga';
import referralSaga from './referralSaga';
import blacklistSaga from './blacklistSaga';
import tagSaga from './tagSaga';
import brandPaymentSaga from './brandPaymentSaga';
import reportingSaga from './reportingSaga';
import operatorLimitSaga from './operatorLimitSaga';
import legalAgreementSaga from './legalAgreementSaga';
import accountUpdatesSaga from './accountUpdatesSaga';
import cashierSaga from './cashierSaga';
import gameSegmentSaga from './gameSegmentSaga';
import playerSegmentSaga from './playerSegmentSaga';
import playerPerformanceSaga from './playerPerformanceSaga';
import systemConversionSaga from './systemConversionSaga';
import gameManagementSaga from './gameManagementSaga';
import overviewSaga from './overviewSaga';
import previousAccount from './previousAccountSaga';
import reasonsSaga from './reasonsSaga';
import campaignSaga from './campaignSaga';
import taxesSaga from './taxesSaga';
import lobbyManagementSaga from './lobbyManagementSaga';
import brandMarketSaga from './brandMarketSaga';
import exportCenterSaga from './exportCenterSaga';
import playerWalletSaga from './playerWalletSaga';
import betStatusCorrectionSaga from './betStatusCorrectionSaga';
import releaseNote from './releaseNoteSaga';
import playerSession from './playerSessionSaga';
import campaignV2 from './campaignV2Saga';
import playerComplaint from './playerComplaintSaga';
import selfAssessments from './selfAssessmentSaga';
import systemSetting from './systemSettingSaga';
import userActions from './userActionsSaga';
import superiorCountries from './superiorCountriesSaga';

export default function* rootSaga() {
  yield all([
    playerSaga(),
    brandSaga(),
    brandSettingSaga(),
    brandMarketSaga(),
    notificationSaga(),
    translationSaga(),
    templateSaga(),
    fileManagerSaga(),
    gameSaga(),
    promoCodeSaga(),
    bonusSaga(),
    cashBackSaga(),
    referralSaga(),
    tagSaga(),
    blacklistSaga(),
    brandPaymentSaga(),
    reportingSaga(),
    operatorLimitSaga(),
    legalAgreementSaga(),
    accountUpdatesSaga(),
    cashierSaga(),
    gameSegmentSaga(),
    playerSegmentSaga(),
    playerPerformanceSaga(),
    systemConversionSaga(),
    gameManagementSaga(),
    overviewSaga(),
    previousAccount(),
    reasonsSaga(),
    campaignSaga(),
    taxesSaga(),
    lobbyManagementSaga(),
    exportCenterSaga(),
    playerWalletSaga(),
    betStatusCorrectionSaga(),
    releaseNote(),
    playerSession(),
    campaignV2(),
    playerComplaint(),
    selfAssessments(),
    systemSetting(),
    userActions(),
    superiorCountries(),
  ]);
}
